import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useEffect, useRef } from 'react';
import { useBusinessChannelEventBinder } from '~/pusher/useBusinessChannelEventBinder';
import { useTasksJobs } from '../../hooks/useTasksJobs';
function patchTask(task, payload) {
    if (payload.status === 'ready') {
        return _object_spread_props(_object_spread({}, task), {
            status: 'ready',
            progress: 100,
            downloadUrl: payload.downloadUrl,
            fileName: payload.fileName,
            updatedAt: Date.now()
        });
    }
    if (payload.status === 'failed') {
        return _object_spread_props(_object_spread({}, task), {
            status: 'failed',
            progress: 100,
            error: payload.error,
            updatedAt: Date.now()
        });
    }
    return _object_spread_props(_object_spread({}, task), {
        status: payload.status,
        progress: payload.progress
    });
}
export function useRelationshipPdfChannelBinder() {
    const { startListening, unbind } = useBusinessChannelEventBinder('RelationshipPdfUpdate', 'scout');
    const { optimisticUpdate, refresh } = useTasksJobs();
    const unbindRef = useRef(unbind);
    unbindRef.current = unbind;
    useEffect(()=>{
        startListening((payload)=>{
            if (payload.kind !== 'relationshipPdf') return;
            let matched = false;
            optimisticUpdate((tasks)=>{
                matched = tasks.some((t)=>t.jobId === payload.jobId);
                if (!matched) return tasks;
                return tasks.map((t)=>t.jobId === payload.jobId ? patchTask(t, payload) : t);
            });
            if (!matched) void refresh();
        });
        return ()=>unbindRef.current();
    }, [
        startListening,
        optimisticUpdate,
        refresh
    ]);
}
